import type { CoverSheetConfigCard } from '../../../types';

export const leaseAgreementDatesCard = {
  id: 'propertyInfo.leaseAgreementDates',
  innerTitle: 'Lease Agreement Dates',
  legend: '',
  layout: [
    [
      {
        name: 'leaseStartDate',
        size: 33,
      },
      {
        name: 'leaseEndDate',
        size: 33,
      },
      {
        name: 'paymentDate',
        size: 33,
      },
    ],
  ],
  fields: {
    leaseStartDate: {
      name: 'leaseStartDate',
      entity: 'interaction',
      type: 'date',
      label: 'Lease Start Date',
      placeholderText: '',
    },
    leaseEndDate: {
      name: 'leaseEndDate',
      entity: 'interaction',
      type: 'date',
      label: 'Lease End Date',
      placeholderText: '',
    },
    paymentDate: {
      name: 'paymentDate',
      entity: 'interaction',
      type: 'date',
      label: 'Expected Payment Date',
      placeholderText: '',
      tooltip: 'The date the brokerage expects payment',
    },
  },
} satisfies CoverSheetConfigCard;
